import type { LocalEstoqueInput, RecursoEstoqueInput } from "./types";

export function calcAreaTotalOs(locais: LocalEstoqueInput[]): number {
  return locais.reduce((sum, local) => sum + (Number(local.areaEfetiva) || 0), 0);
}

export function calcProgramadoNestaOs(
  dose: number,
  areaTotalOs: number,
  porcentagemUtilizacao: number,
): number {
  return dose * areaTotalOs * (porcentagemUtilizacao / 100);
}

export function calcPrevisaoEstoque(
  estoqueFazenda: number,
  programadoEmOs: number,
  programadoNestaOs: number,
): number {
  return estoqueFazenda - (programadoEmOs + programadoNestaOs);
}

export function calcProgramadoNestaOsFromRecurso(
  recurso: RecursoEstoqueInput,
  areaTotalOs: number,
): number {
  const dose = Number(recurso.quantidade) || 0;
  const utilizacao = Number(recurso.porcentagemUtilizacao) || 0;
  return calcProgramadoNestaOs(dose, areaTotalOs, utilizacao);
}
